/**
 * component to render in tdeclarations tab at How to Nominate page DTA
 */
const DeclarationsSection = (): React.ReactElement => {
  return (
    <div
      className="mb-5 bg-gray-150 px-6 pb-4 pt-4 font-public-sans"
      data-testid="declarations-section-component"
    >
      <ul className="list-outside list-decimal pl-8 leading-[1.4]">
        <li className="mb-3">
          <p className="mb-3">
            By submitting this nomination form in relation to the Design AI and
            Tech Awards (“Award”), each nominator hereby agrees with SPH Media
            and SUTD (collectively, “the organisers”) to be bound by and comply
            with all the terms and conditions in this form (“Terms &
            Conditions”):
          </p>

          <p>
            a) that all figures provided in the nomination form, except for the
            gross operating profit figures, are non-confidential information and
            may be published and used for research and analytics purposes;
          </p>

          <p>
            b) to provide relevant company information should the organisers
            need to verify the data provided in the nomination form (upon
            request);
          </p>

          <p>
            c) to provide the company’s projected financial figures for the
            relevant financial periods (upon request);
          </p>

          <p>
            d) to notify the organisers in the event your company, holding
            company or subsidiaries have successfully applied for public listing
            and expect such a listing to occur;
          </p>

          <p>
            e) to notify the organisers in the event of any changes to your
            company&apos;s eligibility for the Award;
          </p>

          <p>
            f) to provide details of any litigation cases against your company
            and/or your company&apos;s directors/shareholders in the run-up to
            the publication of the Award listing;
          </p>

          <p>
            g) to abide by the publicity schedules and guidelines stipulated by
            the organisers in the run-up to and after the publication of the
            Award listing;
          </p>

          <p>
            h) to provide relevant information about your company for purposes
            of inclusion in Award-related collaterals, including but not limited
            to books, write-ups, etc.;
          </p>

          <p>
            i) to abide by the rules and standards regarding the usage of the
            Award logo as notified to you by the organisers or otherwise
            available on
            https://www.businesstimes.com.sg/events-awards/design-ai-and-tech-awards
          </p>
        </li>

        <li className="mb-3">
          <p className="mb-3">Each nominator further agrees and consents to:</p>

          <p>
            a) the terms of SPH Media Privacy Policy which can be found at
            https://www.sph.com.sg/tnc/privacy as amended from time to time, and
            the terms of the Privacy Policy are incorporated into these Terms &
            Conditions by reference;
          </p>

          <p>
            b) the terms of SPH Media Member Terms and Conditions, which can be
            found at https://www.sph.com.sg/tnc/member as amended from time to
            time, and the terms of the SPH Media Member Terms and Conditions are
            incorporated into these Terms & Conditions by reference. In the
            event of conflict between these Terms & Conditions and the SPH Media
            Member Terms and Conditions, these Terms & Conditions shall prevail;
          </p>

          <p>
            c) SPH Media, SUTD and their related corporations and the partners
            and sponsors of the Award, as well as their respective
            representatives, agents or authorised service providers, collecting,
            using and disclosing any and all personal data and sharing the
            personal data between themselves and their business parties to
            communicate with the individuals for purposes related to the
            nomination and the Award, to provide goods and services to the
            individuals upon request, to send the individuals marketing
            information on products and services offered by SPH Media or other
            parties, and for such purposes that the individuals may have
            otherwise given his/her consent to SPH Media;
          </p>

          <p>
            d) SPH Media, SUTD as well as their respective representatives,
            agents or authorised service providers, collecting, using,
            disclosing and processing the personal data, and sharing between
            themselves and their business partners the personal data, including
            the photographs or audio-video or other recordings of these
            participants (“Material”) for publicity and/or use in advertisements
            across all media, including, without limitation, in SPH Media’s
            publications, presentations, promotional materials on their websites
            and social media, in its original or edited format, and whether to
            promote the Award or otherwise without further notification,
            remuneration or compensation; and
          </p>

          <p>
            e) the copyright and all other intellectual property rights in and
            to all Material shall vest solely and absolutely in SPH Media
            without further compensation, and to the maximum extent permissible
            under law, each nominator hereby waives his/her moral rights
            comprised in and to all Material in favour of SPH Media.
          </p>
        </li>

        <li className="mb-3">
          <p className="mb-3">
            Additionally, each nominator hereby represents to SPH Media and SUTD
            that:
          </p>

          <p>
            a) the particulars and information furnished to SPH Media and SUTD
            in this form are true and correct, and have satisfied the assessment
            criteria stipulated by the organisers;
          </p>

          <p>
            b) where he/she provides SPH Media and SUTD with any personal data
            relating to a third party (e.g. a nominee and nominee’s
            officers/employees), by submitting such information to us, he/she
            represents to SPH Media and SUTD that he/she has obtained the
            consent of the third party to enable he/she to provide SPH Media and
            SUTD with the third party’s personal data for the respective
            purposes;
          </p>

          <p>
            c) all intellectual property rights comprising the innovations
            furnished to SPH Media and SUTD for this Award is his/her/the
            company’s original work and has not been copied wholly or
            substantially from any other source or infringed any third party
            intellectual property rights.
          </p>
        </li>

        <li>
          Each nominator agrees to indemnify and hold SPH Media, SUTD and their
          respective officers, employees and agents (collectively, “Indemnified
          Parties”) harmless against all proceedings, suits, actions, claims,
          demands, costs and expenses whatsoever which may be taken or made
          against or incurred or become payable by any of the Indemnified
          Parties in respect of any breaches of any of the obligations,
          undertakings, representations or conditions set out in this Terms and
          Conditions.
        </li>

        <li>
          Nominators are required to provide their particulars for the purpose
          of verification and audit.
        </li>

        <li>
          The decisions of the evaluation panel on the Award are final and
          conclusive, and no appeals will be entertained. SPH Media and SUTD
          reserve their rights to revoke an Award in the event of non-compliance
          with any of the above conditions.
        </li>

        <li>
          SPH Media and SPH Media’s partners, SUTD and/or sponsors for the Award
          (if applicable) shall not be liable for any loss (including, without
          limitation, indirect or consequential loss), damage, personal injury
          or death in connection with the Award or prize, except any liability
          that cannot be excluded by law (in which case that liability is
          limited to the minimum allowable by law).
        </li>

        <li>
          For purposes of these Terms & Conditions, “SPH Media” means SPH Media
          Limited and its related corporations, and “SUTD” means Singapore
          University of Technology and Design.
        </li>

        <li className="pb-4">
          Submission of this nomination form is deemed acceptance of these Terms
          & Conditions and any amendments and modifications hereto, which shall
          be final and binding in all respects on each nominator.
        </li>
      </ul>

      <p>
        Amendments to these Terms & Conditions will be posted at
        https://www.businesstimes.com.sg/events-awards/design-ai-and-tech-awards.
      </p>
    </div>
  );
};

export default DeclarationsSection;
